import { useState } from "react";
import axios from "../../../axios";
import { useNavigate, Link } from "react-router-dom";
import handleApiError from "../../../utils/handleApiError";
import FullPageLoader from "../../components/FullPageLoader";


export default function CategoryCreatePage() {
    const [form, setForm] = useState({ name: "", slug: "", prefix: "" });
    const [subcategories, setSubcategories] = useState([{ name: "", prefix: "" }]);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);


    const handleCategoryChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubChange = (index, field, value) => {
        const updated = [...subcategories];
        updated[index][field] = value;
        setSubcategories(updated);
    };

    const addSubcategoryField = () => {
        setSubcategories([...subcategories, { name: "", prefix: "" }]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await axios.post("/admin/categories", form);
            const category = res.data;

            // Simpan subcategories
            for (const sub of subcategories) {
                if (sub.name && sub.prefix) {
                    await axios.post("/admin/sub-categories", {
                        ...sub,
                        category_id: category.id,
                    });
                }
            }

            navigate("/admin/categories");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveSubcategory = (index) => {
    const updated = subcategories.filter((_, i) => i !== index);
    setSubcategories(updated);
    };

    return (
        <div>
            {loading && <FullPageLoader />}

            <div className="card mt-24">
                <div class="card-header border-bottom">
                    <h4 class="mb-4">Add Category & SubCategory</h4>
                </div>
                <div class="card-body">
                {error && <p style={{ color: "red" }}>{error}</p>}

                <form onSubmit={handleSubmit}>
                    <h3>Informasi Kategori</h3>
                    <div class="row gy-4">
                    <div className="col-sm-6 col-xs-6">
                        <label className="form-label mb-8 h6">Category Name</label>
                        <input name="name" className="form-control py-11" placeholder="Enter Category Name" value={form.name} onChange={handleCategoryChange} required />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                        <label className="form-label mb-8 h6">Slug (optional)</label>
                        <input name="slug" className="form-control py-11" placeholder="Slug (opsional)" value={form.slug} onChange={handleCategoryChange} />
                    </div>
                    <div className="col-sm-6 col-xs-6">
                        <label className="form-label mb-8 h6">Prefix</label>
                        <input name="prefix" className="form-control py-11" placeholder="Prefix Kategori" value={form.prefix} onChange={handleCategoryChange} required />
                    </div>
                    </div>
                    
                    

                    <h3>SubKategori</h3>
                    <div class="row gy-4">
                    {subcategories.map((sub, i) => (
                        <div key={i} style={{ marginBottom: "0.5rem" }} className="col-sm-6 col-xs-6">
                            <input
                                placeholder="Nama SubKategori"
                                value={sub.name}
                                onChange={(e) => handleSubChange(i, "name", e.target.value)}
                                required
                                className="form-control py-11"
                            />
                            <input
                                placeholder="Prefix SubKategori"
                                value={sub.prefix}
                                onChange={(e) => handleSubChange(i, "prefix", e.target.value)}
                                required
                                className="form-control py-11"
                            />
                            {subcategories.length > 1 && (
                            <button type="button" className="btn py-9" onClick={() => handleRemoveSubcategory(i)} style={{ backgroundColor: "red", color: "white" }}>
                                Hapus
                            </button>
                            )}
                            <hr />
                        </div>
                    ))}
                    </div>
                    <button type="button" className="btn btn-main py-9" onClick={addSubcategoryField}>+ Tambah SubKategori</button>
                    <br /><br />
                    <button className="btn btn-main py-9" type="submit">Simpan</button>
                    <Link to="/admin/categories">
                        <button className="btn btn-secondary py-9 mx-3">Kembali</button>
                    </Link>
                </form>
                </div>
            </div>
        </div>
    );
}
